import state from "./moduleDepartmentState.js";
import mutations from "./moduleDepartmentMutation.js";
import actions from "./moduleDepartmentActions.js";
import getters from "./moduleDepartmentGetters.js";

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};
